var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area dashboard",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz location-listing" }, [
        _c(
          "div",
          {
            staticClass: "page-header-top-container",
            staticStyle: { position: "fixed" }
          },
          [
            _c(
              "div",
              { staticClass: "page-name", staticStyle: { width: "40%" } },
              [_vm._v("Parts Usage Summary")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary waves-effect pull-right",
                attrs: { type: "submit" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.loadPartDepletionHistory(true)
                  }
                }
              },
              [_vm._v("Export")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "extraFeature btn btn-primary waves-effect pull-right ml-2",
                attrs: { type: "submit", id: "refreshList", title: "Refresh" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.loadPartDepletionHistory(false)
                  }
                }
              },
              [
                _c("i", {
                  staticClass: "fa fa-rotate-right",
                  attrs: { "aria-hidden": "true" }
                })
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "page-name" }),
            _vm._v(" "),
            _c("div", { staticClass: "selectbtn" })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "admin-page-content",
            staticStyle: { "padding-top": "80px" }
          },
          [
            _c("label", { staticClass: "policy-text" }, [
              _vm._v(
                "** Total displayed below does not include Tax and Core Charges"
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("label", { staticClass: "policy-text" }, [
              _vm._v(
                '** Please enter the PO Number displayed in the PO Number column prefixed with "CI-" when generating Invoice in Excede'
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { class: "app-filter-good-table-container " + _vm.isAdminClass },
              [
                _c("vue-good-table", {
                  ref: "listInventory",
                  attrs: {
                    mode: "remote",
                    title: "Dashboard",
                    totalRows: _vm.totalRecords,
                    columns: _vm.columns,
                    rows: _vm.rows,
                    selectOptions: _vm.dynamicSelectOptions,
                    "row-style-class": _vm.rowStyleClassFn,
                    "pagination-options": {
                      enabled: true,
                      mode: "pages",
                      pageLabel: "Page",
                      position: "both",
                      perPage: _vm.serverParams.perPage,
                      setCurrentPage: _vm.serverParams.setCurrentPage,
                      perPageDropdown: [25, 50, 100, 200, 500],
                      dropdownAllowAll: false
                    },
                    "search-options": {
                      enabled: false
                    }
                  },
                  on: {
                    "on-page-change": _vm.onPageChange,
                    "on-column-filter": _vm.onColumnFilter,
                    "on-per-page-change": _vm.onPerPageChange,
                    "on-sort-change": _vm.onSortChange,
                    "on-selected-rows-change": _vm.selectionChanged
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "pagination-top",
                        fn: function(props) {
                          return [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "vgt-wrap__footer top-pagination crm"
                              },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-sm-12 col-md-2 PerPage"
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          title: "Select Per Page",
                                          name: "customPerPage",
                                          id: "customPerPage",
                                          label: "text",
                                          clearable: false,
                                          searchable: false,
                                          filterable: false,
                                          options:
                                            _vm.serverParams.perPageDropdown,
                                          placeholder: "Select Per Page"
                                        },
                                        on: {
                                          change: _vm.changedValueTask,
                                          input: function($event) {
                                            return _vm.changedValueTaskCustomPerPageTask()
                                          }
                                        },
                                        model: {
                                          value: _vm.serverParams.perPage,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.serverParams,
                                              "perPage",
                                              $$v
                                            )
                                          },
                                          expression: "serverParams.perPage"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "mt-2 col-sm-12 col-md-2 RowsDisplay"
                                    },
                                    [
                                      _c("p", { staticClass: "pageRowCount" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.paginationDisplayRowsTask
                                          ) +
                                            " of " +
                                            _vm._s(_vm.totalRecords)
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-sm-12 col-md-6 Pagination"
                                    },
                                    [
                                      _c(
                                        "ul",
                                        { staticClass: "pagination" },
                                        [
                                          _c(
                                            "li",
                                            {
                                              staticClass: "FirstPage",
                                              attrs: { title: "First Page" }
                                            },
                                            [
                                              Number(_vm.serverParams.page) == 1
                                                ? [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "page-link",
                                                        attrs: {
                                                          href:
                                                            "javascript:void(0)"
                                                        }
                                                      },
                                                      [_vm._v("1")]
                                                    )
                                                  ]
                                                : [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "page-link",
                                                        attrs: {
                                                          href:
                                                            "javascript:void(0)"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.onPerticularPageClickTask(
                                                              1
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("1")]
                                                    )
                                                  ]
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "li",
                                            {
                                              staticClass:
                                                "page-item PreviousPage",
                                              attrs: { title: "Previous Page" }
                                            },
                                            [
                                              Number(_vm.serverParams.page) == 1
                                                ? [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "page-link",
                                                        attrs: {
                                                          href:
                                                            "javascript:void(0)",
                                                          tabindex: "-1"
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-angle-left"
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                : [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "page-link",
                                                        attrs: {
                                                          href:
                                                            "javascript:void(0)",
                                                          tabindex: "-1"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.onPerticularPageClickTask(
                                                              Number(
                                                                _vm.serverParams
                                                                  .page
                                                              ) - 1
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-angle-left"
                                                        })
                                                      ]
                                                    )
                                                  ]
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _vm.pageNumberListTask() <
                                          _vm.displayPageTask
                                            ? [
                                                _vm._l(
                                                  _vm.pageNumberListTask(),
                                                  function(n, index) {
                                                    return [
                                                      n ==
                                                      Number(
                                                        _vm.serverParams.page
                                                      )
                                                        ? _c(
                                                            "li",
                                                            {
                                                              staticClass:
                                                                "PagesClass page-item active",
                                                              attrs: {
                                                                title:
                                                                  "Page " + n,
                                                                id:
                                                                  "pageNumber" +
                                                                  n
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "page-link",
                                                                  attrs: {
                                                                    href:
                                                                      "javascript:void(0)"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                            " +
                                                                      _vm._s(
                                                                        n
                                                                      ) +
                                                                      "\n                                                        "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        : _c(
                                                            "li",
                                                            {
                                                              staticClass:
                                                                "PagesClass page-item",
                                                              attrs: {
                                                                title:
                                                                  "Page " + n,
                                                                id:
                                                                  "pageNumber" +
                                                                  n
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.onPerticularPageClickTask(
                                                                    n
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "page-link",
                                                                  attrs: {
                                                                    href:
                                                                      "javascript:void(0)"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                            " +
                                                                      _vm._s(
                                                                        n
                                                                      ) +
                                                                      "\n                                                        "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                    ]
                                                  }
                                                )
                                              ]
                                            : [
                                                Number(_vm.serverParams.page) <=
                                                _vm.pageCompareTask
                                                  ? [
                                                      _vm._l(
                                                        _vm.displayPageTask,
                                                        function(n, index) {
                                                          return [
                                                            n ==
                                                            Number(
                                                              _vm.serverParams
                                                                .page
                                                            )
                                                              ? _c(
                                                                  "li",
                                                                  {
                                                                    staticClass:
                                                                      "PagesClass page-item active",
                                                                    attrs: {
                                                                      title:
                                                                        "Page " +
                                                                        n,
                                                                      id:
                                                                        "pageNumber" +
                                                                        n
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        staticClass:
                                                                          "page-link",
                                                                        attrs: {
                                                                          href:
                                                                            "javascript:void(0)"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                                " +
                                                                            _vm._s(
                                                                              n
                                                                            ) +
                                                                            "\n                                                            "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              : _c(
                                                                  "li",
                                                                  {
                                                                    staticClass:
                                                                      "PagesClass page-item",
                                                                    attrs: {
                                                                      title:
                                                                        "Page " +
                                                                        n,
                                                                      id:
                                                                        "pageNumber" +
                                                                        n
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.onPerticularPageClickTask(
                                                                          n
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        staticClass:
                                                                          "page-link",
                                                                        attrs: {
                                                                          href:
                                                                            "javascript:void(0)"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                                " +
                                                                            _vm._s(
                                                                              n
                                                                            ) +
                                                                            "\n                                                            "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                          ]
                                                        }
                                                      )
                                                    ]
                                                  : Number(
                                                      _vm.serverParams.page
                                                    ) >=
                                                    _vm.pageNumberListTask() -
                                                      (_vm.pageCompareTask - 1)
                                                  ? [
                                                      _vm._l(
                                                        _vm.pageNumberListTask(),
                                                        function(n, index) {
                                                          return [
                                                            n >
                                                            _vm.pageNumberListTask() -
                                                              _vm.displayPageTask
                                                              ? [
                                                                  n ==
                                                                  Number(
                                                                    _vm
                                                                      .serverParams
                                                                      .page
                                                                  )
                                                                    ? _c(
                                                                        "li",
                                                                        {
                                                                          staticClass:
                                                                            "PagesClass page-item active",
                                                                          attrs: {
                                                                            title:
                                                                              "Page " +
                                                                              n,
                                                                            id:
                                                                              "pageNumber" +
                                                                              n
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "a",
                                                                            {
                                                                              staticClass:
                                                                                "page-link",
                                                                              attrs: {
                                                                                href:
                                                                                  "javascript:void(0)"
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                                                    " +
                                                                                  _vm._s(
                                                                                    n
                                                                                  ) +
                                                                                  "\n                                                                "
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _c(
                                                                        "li",
                                                                        {
                                                                          staticClass:
                                                                            "PagesClass page-item",
                                                                          attrs: {
                                                                            title:
                                                                              "Page " +
                                                                              n,
                                                                            id:
                                                                              "pageNumber" +
                                                                              n
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.onPerticularPageClickTask(
                                                                                n
                                                                              )
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "a",
                                                                            {
                                                                              staticClass:
                                                                                "page-link",
                                                                              attrs: {
                                                                                href:
                                                                                  "javascript:void(0)"
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                                                    " +
                                                                                  _vm._s(
                                                                                    n
                                                                                  ) +
                                                                                  "\n                                                                "
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                ]
                                                              : _vm._e()
                                                          ]
                                                        }
                                                      )
                                                    ]
                                                  : [
                                                      _vm._l(
                                                        _vm.pageNumberListTask(),
                                                        function(n, index) {
                                                          return n >=
                                                            Number(
                                                              _vm.serverParams
                                                                .page
                                                            ) -
                                                              (_vm.pageCompareTask -
                                                                1) &&
                                                            n <=
                                                              Number(
                                                                _vm.serverParams
                                                                  .page
                                                              ) +
                                                                (_vm.pageCompareTask -
                                                                  1)
                                                            ? [
                                                                n ==
                                                                Number(
                                                                  _vm
                                                                    .serverParams
                                                                    .page
                                                                )
                                                                  ? _c(
                                                                      "li",
                                                                      {
                                                                        staticClass:
                                                                          "PagesClass page-item active",
                                                                        attrs: {
                                                                          title:
                                                                            "Page " +
                                                                            n,
                                                                          id:
                                                                            "pageNumber" +
                                                                            n
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            staticClass:
                                                                              "page-link",
                                                                            attrs: {
                                                                              href:
                                                                                "javascript:void(0)"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                                " +
                                                                                _vm._s(
                                                                                  n
                                                                                ) +
                                                                                "\n                                                            "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _c(
                                                                      "li",
                                                                      {
                                                                        staticClass:
                                                                          "PagesClass page-item",
                                                                        attrs: {
                                                                          title:
                                                                            "Page " +
                                                                            n,
                                                                          id:
                                                                            "pageNumber" +
                                                                            n
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.onPerticularPageClickTask(
                                                                              n
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            staticClass:
                                                                              "page-link",
                                                                            attrs: {
                                                                              href:
                                                                                "javascript:void(0)"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                                " +
                                                                                _vm._s(
                                                                                  n
                                                                                ) +
                                                                                "\n                                                            "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                              ]
                                                            : _vm._e()
                                                        }
                                                      )
                                                    ]
                                              ],
                                          _vm._v(" "),
                                          _c(
                                            "li",
                                            {
                                              staticClass: "page-item NextPage",
                                              attrs: { title: "Next Page" }
                                            },
                                            [
                                              Number(_vm.serverParams.page) ==
                                              _vm.pageNumberListTask()
                                                ? [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "page-link",
                                                        attrs: {
                                                          href:
                                                            "javascript:void(0)"
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-angle-right"
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                : [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "page-link",
                                                        attrs: {
                                                          href:
                                                            "javascript:void(0)"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.onPerticularPageClickTask(
                                                              Number(
                                                                _vm.serverParams
                                                                  .page
                                                              ) + 1
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-angle-right"
                                                        })
                                                      ]
                                                    )
                                                  ]
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "li",
                                            {
                                              staticClass: "LastPage",
                                              attrs: { title: "Last Page" }
                                            },
                                            [
                                              Number(_vm.serverParams.page) ==
                                              _vm.pageNumberListTask()
                                                ? [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "page-link",
                                                        attrs: {
                                                          href:
                                                            "javascript:void(0)",
                                                          tabindex: "-1"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.pageNumberListTask()
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                : [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "page-link",
                                                        attrs: {
                                                          href:
                                                            "javascript:void(0)",
                                                          tabindex: "-1"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.onPerticularPageClickTask(
                                                              _vm.pageNumberListTask()
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.pageNumberListTask()
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                            ],
                                            2
                                          )
                                        ],
                                        2
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6"
                                    },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "pageJumpLabel" },
                                        [_vm._v("Page : ")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6"
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.jumpToPageTask,
                                            expression: "jumpToPageTask"
                                          }
                                        ],
                                        staticClass:
                                          "form-control form-control-sm",
                                        attrs: {
                                          type: "text",
                                          name: "jumpToPageTask",
                                          id: "jumpToPageTask",
                                          placeholder: "Page"
                                        },
                                        domProps: { value: _vm.jumpToPageTask },
                                        on: {
                                          keyup: function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            return _vm.jumpToPageInTask.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.jumpToPageTask =
                                              $event.target.value
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ])
                              ]
                            )
                          ]
                        }
                      },
                      {
                        key: "pagination-bottom",
                        fn: function(props) {
                          return [
                            _c("div", { staticClass: "vgt-wrap__footer crm" }, [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-sm-12 col-md-2 PerPage" },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        title: "Select Per Page",
                                        name: "customPerPage",
                                        id: "customPerPage",
                                        label: "text",
                                        clearable: false,
                                        searchable: false,
                                        filterable: false,
                                        options:
                                          _vm.serverParams.perPageDropdown,
                                        placeholder: "Select Per Page"
                                      },
                                      on: {
                                        change: _vm.changedValueTask,
                                        input: function($event) {
                                          return _vm.changedValueTaskCustomPerPageTask()
                                        }
                                      },
                                      model: {
                                        value: _vm.serverParams.perPage,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.serverParams,
                                            "perPage",
                                            $$v
                                          )
                                        },
                                        expression: "serverParams.perPage"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "mt-2 col-sm-12 col-md-2 RowsDisplay"
                                  },
                                  [
                                    _c("p", { staticClass: "pageRowCount" }, [
                                      _vm._v(
                                        _vm._s(_vm.paginationDisplayRowsTask) +
                                          " of " +
                                          _vm._s(_vm.totalRecords)
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "col-sm-12 col-md-6 Pagination"
                                  },
                                  [
                                    _c(
                                      "ul",
                                      { staticClass: "pagination" },
                                      [
                                        _c(
                                          "li",
                                          {
                                            staticClass: "FirstPage",
                                            attrs: { title: "First Page" }
                                          },
                                          [
                                            Number(_vm.serverParams.page) == 1
                                              ? [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass: "page-link",
                                                      attrs: {
                                                        href:
                                                          "javascript:void(0)"
                                                      }
                                                    },
                                                    [_vm._v("1")]
                                                  )
                                                ]
                                              : [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass: "page-link",
                                                      attrs: {
                                                        href:
                                                          "javascript:void(0)"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.onPerticularPageClickTask(
                                                            1
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("1")]
                                                  )
                                                ]
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "page-item PreviousPage",
                                            attrs: { title: "Previous Page" }
                                          },
                                          [
                                            Number(_vm.serverParams.page) == 1
                                              ? [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass: "page-link",
                                                      attrs: {
                                                        href:
                                                          "javascript:void(0)",
                                                        tabindex: "-1"
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-angle-left"
                                                      })
                                                    ]
                                                  )
                                                ]
                                              : [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass: "page-link",
                                                      attrs: {
                                                        href:
                                                          "javascript:void(0)",
                                                        tabindex: "-1"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.onPerticularPageClickTask(
                                                            Number(
                                                              _vm.serverParams
                                                                .page
                                                            ) - 1
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-angle-left"
                                                      })
                                                    ]
                                                  )
                                                ]
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _vm.pageNumberListTask() <
                                        _vm.displayPageTask
                                          ? [
                                              _vm._l(
                                                _vm.pageNumberListTask(),
                                                function(n, index) {
                                                  return [
                                                    n ==
                                                    Number(
                                                      _vm.serverParams.page
                                                    )
                                                      ? _c(
                                                          "li",
                                                          {
                                                            staticClass:
                                                              "PagesClass page-item active",
                                                            attrs: {
                                                              title:
                                                                "Page " + n,
                                                              id:
                                                                "pageNumber" + n
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "page-link",
                                                                attrs: {
                                                                  href:
                                                                    "javascript:void(0)"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                            " +
                                                                    _vm._s(n) +
                                                                    "\n                                                        "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _c(
                                                          "li",
                                                          {
                                                            staticClass:
                                                              "PagesClass page-item",
                                                            attrs: {
                                                              title:
                                                                "Page " + n,
                                                              id:
                                                                "pageNumber" + n
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onPerticularPageClickTask(
                                                                  n
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "page-link",
                                                                attrs: {
                                                                  href:
                                                                    "javascript:void(0)"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                            " +
                                                                    _vm._s(n) +
                                                                    "\n                                                        "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                  ]
                                                }
                                              )
                                            ]
                                          : [
                                              Number(_vm.serverParams.page) <=
                                              _vm.pageCompareTask
                                                ? [
                                                    _vm._l(
                                                      _vm.displayPageTask,
                                                      function(n, index) {
                                                        return [
                                                          n ==
                                                          Number(
                                                            _vm.serverParams
                                                              .page
                                                          )
                                                            ? _c(
                                                                "li",
                                                                {
                                                                  staticClass:
                                                                    "PagesClass page-item active",
                                                                  attrs: {
                                                                    title:
                                                                      "Page " +
                                                                      n,
                                                                    id:
                                                                      "pageNumber" +
                                                                      n
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      staticClass:
                                                                        "page-link",
                                                                      attrs: {
                                                                        href:
                                                                          "javascript:void(0)"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                                " +
                                                                          _vm._s(
                                                                            n
                                                                          ) +
                                                                          "\n                                                            "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            : _c(
                                                                "li",
                                                                {
                                                                  staticClass:
                                                                    "PagesClass page-item",
                                                                  attrs: {
                                                                    title:
                                                                      "Page " +
                                                                      n,
                                                                    id:
                                                                      "pageNumber" +
                                                                      n
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.onPerticularPageClickTask(
                                                                        n
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      staticClass:
                                                                        "page-link",
                                                                      attrs: {
                                                                        href:
                                                                          "javascript:void(0)"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                                " +
                                                                          _vm._s(
                                                                            n
                                                                          ) +
                                                                          "\n                                                            "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                        ]
                                                      }
                                                    )
                                                  ]
                                                : Number(
                                                    _vm.serverParams.page
                                                  ) >=
                                                  _vm.pageNumberListTask() -
                                                    (_vm.pageCompareTask - 1)
                                                ? [
                                                    _vm._l(
                                                      _vm.pageNumberListTask(),
                                                      function(n, index) {
                                                        return [
                                                          n >
                                                          _vm.pageNumberListTask() -
                                                            _vm.displayPageTask
                                                            ? [
                                                                n ==
                                                                Number(
                                                                  _vm
                                                                    .serverParams
                                                                    .page
                                                                )
                                                                  ? _c(
                                                                      "li",
                                                                      {
                                                                        staticClass:
                                                                          "PagesClass page-item active",
                                                                        attrs: {
                                                                          title:
                                                                            "Page " +
                                                                            n,
                                                                          id:
                                                                            "pageNumber" +
                                                                            n
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            staticClass:
                                                                              "page-link",
                                                                            attrs: {
                                                                              href:
                                                                                "javascript:void(0)"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                                    " +
                                                                                _vm._s(
                                                                                  n
                                                                                ) +
                                                                                "\n                                                                "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _c(
                                                                      "li",
                                                                      {
                                                                        staticClass:
                                                                          "PagesClass page-item",
                                                                        attrs: {
                                                                          title:
                                                                            "Page " +
                                                                            n,
                                                                          id:
                                                                            "pageNumber" +
                                                                            n
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.onPerticularPageClickTask(
                                                                              n
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            staticClass:
                                                                              "page-link",
                                                                            attrs: {
                                                                              href:
                                                                                "javascript:void(0)"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                                    " +
                                                                                _vm._s(
                                                                                  n
                                                                                ) +
                                                                                "\n                                                                "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                              ]
                                                            : _vm._e()
                                                        ]
                                                      }
                                                    )
                                                  ]
                                                : [
                                                    _vm._l(
                                                      _vm.pageNumberListTask(),
                                                      function(n, index) {
                                                        return n >=
                                                          Number(
                                                            _vm.serverParams
                                                              .page
                                                          ) -
                                                            (_vm.pageCompareTask -
                                                              1) &&
                                                          n <=
                                                            Number(
                                                              _vm.serverParams
                                                                .page
                                                            ) +
                                                              (_vm.pageCompareTask -
                                                                1)
                                                          ? [
                                                              n ==
                                                              Number(
                                                                _vm.serverParams
                                                                  .page
                                                              )
                                                                ? _c(
                                                                    "li",
                                                                    {
                                                                      staticClass:
                                                                        "PagesClass page-item active",
                                                                      attrs: {
                                                                        title:
                                                                          "Page " +
                                                                          n,
                                                                        id:
                                                                          "pageNumber" +
                                                                          n
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "a",
                                                                        {
                                                                          staticClass:
                                                                            "page-link",
                                                                          attrs: {
                                                                            href:
                                                                              "javascript:void(0)"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                                                " +
                                                                              _vm._s(
                                                                                n
                                                                              ) +
                                                                              "\n                                                            "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                : _c(
                                                                    "li",
                                                                    {
                                                                      staticClass:
                                                                        "PagesClass page-item",
                                                                      attrs: {
                                                                        title:
                                                                          "Page " +
                                                                          n,
                                                                        id:
                                                                          "pageNumber" +
                                                                          n
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.onPerticularPageClickTask(
                                                                            n
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "a",
                                                                        {
                                                                          staticClass:
                                                                            "page-link",
                                                                          attrs: {
                                                                            href:
                                                                              "javascript:void(0)"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                                                " +
                                                                              _vm._s(
                                                                                n
                                                                              ) +
                                                                              "\n                                                            "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                            ]
                                                          : _vm._e()
                                                      }
                                                    )
                                                  ]
                                            ],
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            staticClass: "page-item NextPage",
                                            attrs: { title: "Next Page" }
                                          },
                                          [
                                            Number(_vm.serverParams.page) ==
                                            _vm.pageNumberListTask()
                                              ? [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass: "page-link",
                                                      attrs: {
                                                        href:
                                                          "javascript:void(0)"
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-angle-right"
                                                      })
                                                    ]
                                                  )
                                                ]
                                              : [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass: "page-link",
                                                      attrs: {
                                                        href:
                                                          "javascript:void(0)"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.onPerticularPageClickTask(
                                                            Number(
                                                              _vm.serverParams
                                                                .page
                                                            ) + 1
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-angle-right"
                                                      })
                                                    ]
                                                  )
                                                ]
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            staticClass: "LastPage",
                                            attrs: { title: "Last Page" }
                                          },
                                          [
                                            Number(_vm.serverParams.page) ==
                                            _vm.pageNumberListTask()
                                              ? [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass: "page-link",
                                                      attrs: {
                                                        href:
                                                          "javascript:void(0)",
                                                        tabindex: "-1"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.pageNumberListTask()
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass: "page-link",
                                                      attrs: {
                                                        href:
                                                          "javascript:void(0)",
                                                        tabindex: "-1"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.onPerticularPageClickTask(
                                                            _vm.pageNumberListTask()
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.pageNumberListTask()
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                          ],
                                          2
                                        )
                                      ],
                                      2
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6"
                                  },
                                  [
                                    _c("p", { staticClass: "pageJumpLabel" }, [
                                      _vm._v("Page : ")
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6"
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.jumpToPageTask,
                                          expression: "jumpToPageTask"
                                        }
                                      ],
                                      staticClass:
                                        "form-control form-control-sm",
                                      attrs: {
                                        type: "text",
                                        name: "jumpToPageTask",
                                        id: "jumpToPageTask",
                                        placeholder: "Page"
                                      },
                                      domProps: { value: _vm.jumpToPageTask },
                                      on: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.jumpToPageInTask.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.jumpToPageTask =
                                            $event.target.value
                                        }
                                      }
                                    })
                                  ]
                                )
                              ])
                            ])
                          ]
                        }
                      },
                      _vm._l(_vm.rows, function(row, key) {
                        return {
                          key: "table-row",
                          fn: function(props) {
                            return [
                              _c("div", { key: key }, [
                                props.column.field == "action" &&
                                props.formattedRow["customer_excede_id"] !=
                                  "Total"
                                  ? _c(
                                      "div",
                                      [
                                        _vm.isNonVVGDealer == "NO"
                                          ? [
                                              _vm.app_country == "US"
                                                ? [
                                                    _vm.editUserId == 1 ||
                                                    _vm.editUserId == 122 ||
                                                    _vm.editUserId == 110 ||
                                                    _vm.editUserId == 125 ||
                                                    _vm.editUserId == 137
                                                      ? [
                                                          _c(
                                                            "router-link",
                                                            {
                                                              staticClass:
                                                                "btn edit-btn-vvg waves-effect",
                                                              attrs: {
                                                                title:
                                                                  "Edit Inventory",
                                                                to: {
                                                                  name:
                                                                    "UpdatePartDepletionHistory",
                                                                  params: {
                                                                    id:
                                                                      props.row
                                                                        .id
                                                                  }
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa fa-pencil",
                                                                attrs: {
                                                                  "aria-hidden":
                                                                    "true"
                                                                }
                                                              })
                                                            ]
                                                          )
                                                        ]
                                                      : _vm._e()
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.app_country == "AU"
                                                ? [
                                                    _vm.editUserId == 1 ||
                                                    _vm.editUserId == 101 ||
                                                    _vm.editUserId == 121 ||
                                                    _vm.editUserId == 114 ||
                                                    _vm.editUserId == 107 ||
                                                    _vm.editUserId == 110
                                                      ? [
                                                          _c(
                                                            "router-link",
                                                            {
                                                              staticClass:
                                                                "btn edit-btn-vvg waves-effect",
                                                              attrs: {
                                                                title:
                                                                  "Edit Inventory",
                                                                to: {
                                                                  name:
                                                                    "UpdatePartDepletionHistory",
                                                                  params: {
                                                                    id:
                                                                      props.row
                                                                        .id
                                                                  }
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa fa-pencil",
                                                                attrs: {
                                                                  "aria-hidden":
                                                                    "true"
                                                                }
                                                              })
                                                            ]
                                                          )
                                                        ]
                                                      : _vm._e()
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.app_country == "CA"
                                                ? [
                                                    _vm.editUserId == 1 ||
                                                    _vm.editUserId == 3
                                                      ? [
                                                          _c(
                                                            "router-link",
                                                            {
                                                              staticClass:
                                                                "btn edit-btn-vvg waves-effect",
                                                              attrs: {
                                                                title:
                                                                  "Edit Inventory",
                                                                to: {
                                                                  name:
                                                                    "UpdatePartDepletionHistory",
                                                                  params: {
                                                                    id:
                                                                      props.row
                                                                        .id
                                                                  }
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa fa-pencil",
                                                                attrs: {
                                                                  "aria-hidden":
                                                                    "true"
                                                                }
                                                              })
                                                            ]
                                                          )
                                                        ]
                                                      : _vm._e()
                                                  ]
                                                : _vm._e()
                                            ]
                                          : [
                                              _c(
                                                "router-link",
                                                {
                                                  staticClass:
                                                    "btn edit-btn-vvg waves-effect",
                                                  attrs: {
                                                    title: "Edit Inventory",
                                                    to: {
                                                      name:
                                                        "UpdatePartDepletionHistory",
                                                      params: {
                                                        id: props.row.id
                                                      }
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-pencil",
                                                    attrs: {
                                                      "aria-hidden": "true"
                                                    }
                                                  })
                                                ]
                                              )
                                            ],
                                        _vm._v(" "),
                                        _c("i", {
                                          staticClass: "fa fa-info-circle",
                                          staticStyle: {
                                            padding: "5px",
                                            "line-height": "30px",
                                            cursor: "pointer"
                                          },
                                          attrs: { "aria-hidden": "true" },
                                          on: {
                                            click: function($event) {
                                              return _vm.viewNote(
                                                _vm.hideNoteFlag,
                                                props.row,
                                                $event,
                                                "cust"
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "btn edit-btn-vvg waves-effect",
                                            attrs: {
                                              href: "javascript:void(0)",
                                              title:
                                                "Add/Edit Backorder QTY Note"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.addEditBackorderQtyNote(
                                                  props.row.id,
                                                  props.row.back_order_qty_note
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-note",
                                              attrs: { "aria-hidden": "true" }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "btn edit-btn-vvg waves-effect",
                                            attrs: {
                                              href: "javascript:void(0)",
                                              title: "Add/Edit Ticket No"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.addEditTicketNo(
                                                  props.row.id,
                                                  props.row.ticket_no
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-ticket",
                                              attrs: { "aria-hidden": "true" }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn edit-btn-vvg waves-effect",
                                            attrs: {
                                              type: "submit",
                                              id: "noteBtn",
                                              title: "View Note"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.viewNote(
                                                  _vm.hideNoteFlag,
                                                  props.row,
                                                  $event,
                                                  "note"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-comment",
                                              attrs: { "aria-hidden": "true" }
                                            })
                                          ]
                                        )
                                      ],
                                      2
                                    )
                                  : props.column.field == "customer_type"
                                  ? _c(
                                      "div",
                                      [
                                        props.row.customer_type == "Pinnacle"
                                          ? [
                                              _c(
                                                "p",
                                                {
                                                  attrs: {
                                                    title: "Pinnacle Customer"
                                                  }
                                                },
                                                [_vm._v("PIN")]
                                              )
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  : props.column.field == "manager_name"
                                  ? _c("div", [
                                      _c("p", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.addNewLineInInovoiceColumn(
                                              props.formattedRow["manager_name"]
                                            )
                                          )
                                        }
                                      })
                                    ])
                                  : props.column.field ==
                                    "invoice_generate_type"
                                  ? _c(
                                      "div",
                                      [
                                        props.row.invoice_generate_type == "VIP"
                                          ? [
                                              _c("img", {
                                                staticStyle: {
                                                  width: "30px",
                                                  height: "30px"
                                                },
                                                attrs: {
                                                  src: "/static/images/vip.png",
                                                  title: "VIP",
                                                  alt: "VIP"
                                                }
                                              })
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  : props.column.field == "sales_name"
                                  ? _c("div", [
                                      _c("p", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.addNewLineInInovoiceColumn(
                                              props.formattedRow["sales_name"]
                                            )
                                          )
                                        }
                                      })
                                    ])
                                  : props.column.field == "part_name" &&
                                    props.formattedRow["customer_excede_id"] !=
                                      "Total"
                                  ? _c("div", [
                                      _c(
                                        "p",
                                        {
                                          staticStyle: {
                                            "padding-right": "2px"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              props.formattedRow["part_name"]
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-info",
                                          attrs: {
                                            title: "Part# Copy",
                                            type: "button",
                                            id: "copyPartFunction"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.copyFunction(
                                                props.formattedRow["part_name"],
                                                "Part"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-size": "12px"
                                              }
                                            },
                                            [_vm._v("Copy Part #")]
                                          )
                                        ]
                                      )
                                    ])
                                  : props.column.field == "unique_po_number" &&
                                    props.formattedRow["customer_excede_id"] !=
                                      "Total"
                                  ? _c("div", [
                                      _c(
                                        "p",
                                        {
                                          staticStyle: {
                                            "padding-right": "2px"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              props.formattedRow[
                                                "unique_po_number"
                                              ]
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-info",
                                          attrs: {
                                            title: "PO# Copy",
                                            type: "button",
                                            id: "copyPOFunction"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.copyFunction(
                                                props.formattedRow[
                                                  "unique_po_number"
                                                ],
                                                "PO"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-size": "12px"
                                              }
                                            },
                                            [_vm._v("Copy PO #")]
                                          )
                                        ]
                                      )
                                    ])
                                  : props.column.field == "location_name"
                                  ? _c(
                                      "div",
                                      { staticClass: "dashboard-page" },
                                      [
                                        props.row.location
                                          ? [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    props.row.location.text
                                                  )
                                                )
                                              ])
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  : _c("div", [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            props.formattedRow[
                                              props.column.field
                                            ]
                                          ) +
                                          "\n                                "
                                      )
                                    ])
                              ])
                            ]
                          }
                        }
                      }),
                      {
                        key: "selected-row-actions",
                        fn: function(computed) {
                          return _c("div", {}, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(computed.selectedRows) +
                                "\n                            "
                            ),
                            _c(
                              "div",
                              { staticClass: "d-flex" },
                              [
                                _c("v-select", {
                                  staticClass: "shipid-selectbox",
                                  staticStyle: { "min-width": "200px" },
                                  attrs: {
                                    name: "shipId",
                                    placeholder: "Select Ship Id",
                                    label: "text",
                                    options: _vm.shipIdArr,
                                    clearable: false
                                  },
                                  on: { change: _vm.changedShipIdValue },
                                  model: {
                                    value: _vm.shipId,
                                    callback: function($$v) {
                                      _vm.shipId = $$v
                                    },
                                    expression: "shipId"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary my-1 ms-2",
                                    attrs: { id: "sendAppUpdates" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.generateInvoice.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "Generate Invoice(" +
                                        _vm._s(_vm.selectedRows) +
                                        ")"
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "medium-modal" },
          [
            _c(
              "b-modal",
              {
                ref: "add-edit-backorder-note-modal",
                staticClass: "modal-section",
                attrs: {
                  id: "modallg",
                  size: "lg",
                  title: "Add/Edit Backorder QTY Note"
                },
                on: { hidden: _vm.closeModalEvent }
              },
              [
                _c(
                  "form",
                  {
                    attrs: { id: "modalForm", enctype: "multipart/form-data" }
                  },
                  [
                    _c("div", { staticClass: "col-md-12 col-sm-12" }, [
                      _vm._v(
                        "\n                            Note:\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12 col-sm-12" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.boNote,
                            expression: "boNote"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", maxlength: "190" },
                        domProps: { value: _vm.boNote },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.boNote = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "text-danger",
                          staticStyle: { "line-height": "initial", border: "0" }
                        },
                        [_vm._v(_vm._s(_vm.boNoteError))]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "button-demo",
                    staticStyle: { "margin-left": "15px" }
                  },
                  [
                    _c("input", {
                      staticClass: "btn btn-primary",
                      staticStyle: { "margin-top": "10px" },
                      attrs: {
                        id: "addBenifitBtn",
                        disabled: _vm.disableButtons.save,
                        type: "submit"
                      },
                      domProps: { value: _vm.buttonNames.save },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.submitBackorderNote($event)
                        }
                      }
                    })
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                ref: "add-edit-ticket-no-modal",
                staticClass: "modal-section",
                attrs: {
                  id: "modallg",
                  size: "lg",
                  title: "Add/Edit Ticket No"
                },
                on: { hidden: _vm.closeModalEvent }
              },
              [
                _c(
                  "form",
                  {
                    attrs: { id: "modalForm", enctype: "multipart/form-data" }
                  },
                  [
                    _c("div", { staticClass: "col-md-12 col-sm-12" }, [
                      _vm._v(
                        "\n                            Ticket No:\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12 col-sm-12" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.ticketNo,
                            expression: "ticketNo"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", maxlength: "50" },
                        domProps: { value: _vm.ticketNo },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.ticketNo = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "text-danger",
                          staticStyle: { "line-height": "initial", border: "0" }
                        },
                        [_vm._v(_vm._s(_vm.ticketNoError))]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "button-demo",
                    staticStyle: { "margin-left": "15px" }
                  },
                  [
                    _c("input", {
                      staticClass: "btn btn-primary",
                      staticStyle: { "margin-top": "10px" },
                      attrs: {
                        id: "addBenifitBtn",
                        disabled: _vm.disableButtons.saveTicketNo,
                        type: "submit"
                      },
                      domProps: { value: _vm.buttonNames.saveTicketNo },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.submitTicketNo($event)
                        }
                      }
                    })
                  ]
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "page-sidebar" }, [
          _c("div", { staticClass: "noteDetails" }, [
            _vm.type == "note"
              ? _c(
                  "div",
                  [
                    _c("div", { staticClass: "forms-block" }, [
                      _c("div", { staticClass: "pull-right ml-2" }, [
                        _c(
                          "a",
                          {
                            attrs: { id: "cancelNote", title: "Cancel Note" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.cancelNote()
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-times",
                              attrs: { "aria-hidden": "true" }
                            })
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row clearfix" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-label mt-4" }, [
                        _vm._v("Note :")
                      ]),
                      _vm._v(" "),
                      _c("div", {}, [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.notes,
                              expression: "notes"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { name: "notes", id: "notes" },
                          domProps: { value: _vm.notes },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.notes = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "help is-danger" }, [
                          _vm._v(_vm._s(_vm.notesError))
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "mt-3 btn btn-primary themebutton",
                          staticStyle: { float: "left" },
                          attrs: { type: "submit" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.addPartDepletionNote()
                            }
                          }
                        },
                        [
                          _c("span", { attrs: { id: "createAttachment" } }, [
                            _vm._v("Save")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "ml-2 mt-3 btn btn-primary themebutton",
                          staticStyle: { float: "left" },
                          attrs: { type: "submit" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.cancelNote()
                            }
                          }
                        },
                        [
                          _c("span", { attrs: { id: "cancelNote" } }, [
                            _vm._v("Cancel")
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mt-3 sidebar-notes" }, [
                      _vm._v(
                        "\n                            Note List :\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.notesArr && _vm.notesArr.length > 0
                      ? [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-md-12 sidebar-notes-details mt-0"
                            },
                            [
                              _vm._l(_vm.notesArr, function(note, index) {
                                return [
                                  _c("div", { key: index }, [
                                    _c("div", { staticClass: "mb-4" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "username-letter text-center"
                                        },
                                        [_vm._v(_vm._s(note["imgString"]))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "comment-details",
                                          staticStyle: {
                                            display: "inline-block",
                                            "margin-left": "10px"
                                          }
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass: "mb-0 user-name",
                                              staticStyle: {
                                                color: "#098de1",
                                                "font-family":
                                                  "'SanFranciscoDisplayMedium'"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                                    " +
                                                  _vm._s(note["name"]) +
                                                  "\n                                                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              staticClass: "mb-0 comment-date",
                                              staticStyle: {
                                                "font-size": "14px",
                                                color: "#8b8b8b"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                                    " +
                                                  _vm._s(note["date"]) +
                                                  "\n                                                "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "mb-2" }, [
                                      _vm._v(
                                        "\n                                            " +
                                          _vm._s(note["notes"]) +
                                          "\n                                        "
                                      )
                                    ])
                                  ])
                                ]
                              })
                            ],
                            2
                          )
                        ]
                      : [
                          _c("div", { staticClass: "sidebar-notes-details" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.noDataMessaage) +
                                "\n                            "
                            )
                          ])
                        ]
                  ],
                  2
                )
              : _vm.type == "cust"
              ? _c("div", [
                  _c("div", { staticClass: "forms-block" }, [
                    _c("div", { staticClass: "pull-right ml-2" }, [
                      _c(
                        "a",
                        {
                          attrs: { id: "cancelNote", title: "Cancel Note" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.cancelNote()
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-times",
                            attrs: { "aria-hidden": "true" }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row clearfix" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-label" }, [
                      _c("b", [
                        _c("h4", [_vm._v(_vm._s(_vm.cust_info.customer_name))])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-label" }, [
                      _vm._v(
                        "Excede id: (" +
                          _vm._s(_vm.cust_info.customer_excede_id) +
                          ")"
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-label" }, [
                      _vm._v(
                        "Email: " + _vm._s(_vm.cust_info.customer_primary_email)
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-label" }, [
                      _vm._v(
                        "Phone: " +
                          _vm._s(_vm.cust_info.customer_primary_contact)
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-label" }, [
                      _vm._v("Type: " + _vm._s(_vm.cust_info.customer_type))
                    ])
                  ])
                ])
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c("app-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aae30ed8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aae30ed8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = null
// module chunks = 